import React, { useEffect } from 'react';

const CustomSplash = ({ onReady }) => {
  useEffect(() => {
    // Check if running as PWA
    const isStandalone = window.navigator.standalone || 
      window.matchMedia('(display-mode: standalone)').matches;

    const splash = document.getElementById('static-splash');
    
    // Function to check if content is actually ready
    const checkContentReady = () => {
      // Check if AuthContext has finished loading (no more auth loading spinner)
      const authLoading = document.querySelector('.animate-spin');
      if (authLoading) {
        return false;
      }
      
      // Check if main content is rendered (look for common selectors)
      const mainContent = document.querySelector('[data-testid="main-content"], .main-content, #dashboard, #landing, .dashboard, .landing-page');
      const hasContent = mainContent || document.querySelector('.min-h-screen') || document.querySelector('[role="main"]');
      
      return !!hasContent;
    };
    
    // Function to notify Android when content is truly ready
    const notifyAndroidContentReady = () => {
      if (window.AndroidInterface && typeof window.AndroidInterface.notifyContentReady === 'function') {
        console.log('[CustomSplash] Notifying Android that content is ready');
        window.AndroidInterface.notifyContentReady();
      }
    };
    
    // Function to wait for content and then notify
    const waitForContentAndNotify = () => {
      const maxAttempts = 50; // 5 seconds max
      let attempts = 0;
      
      const checkAndNotify = () => {
        attempts++;
        
        if (checkContentReady()) {
          console.log('[CustomSplash] Content is ready after', attempts * 100, 'ms');
          notifyAndroidContentReady();
        } else if (attempts < maxAttempts) {
          setTimeout(checkAndNotify, 100);
        } else {
          console.log('[CustomSplash] Timeout reached, notifying Android anyway');
          notifyAndroidContentReady();
        }
      };
      
      // Start checking
      checkAndNotify();
    };
    
    if (isStandalone && splash) {
      // Show splash screen in PWA mode
      splash.classList.add('show-splash');

      // Wait for app to be ready
      const minDisplayTime = 1000; // Minimum time to show splash screen
      const startTime = Date.now();

      const handleReady = () => {
        const elapsedTime = Date.now() - startTime;
        const remainingTime = Math.max(0, minDisplayTime - elapsedTime);

        // Ensure minimum display time and smooth transition
        setTimeout(() => {
          splash.classList.remove('show-splash');
          // Remove the element after transition
          setTimeout(() => {
            splash.remove();
          }, 500);
          if (onReady) onReady();
          // Wait for content to be ready before notifying Android
          waitForContentAndNotify();
        }, remainingTime);
      };

      // Wait for everything to be loaded
      if (document.readyState === 'complete') {
        handleReady();
      } else {
        window.addEventListener('load', handleReady);
        return () => window.removeEventListener('load', handleReady);
      }
    } else if (splash) {
      // Not in PWA mode, remove splash screen immediately
      splash.remove();
      // Wait for content to be ready before notifying Android
      waitForContentAndNotify();
    } else {
      // No splash element found, still notify Android when content is ready
      waitForContentAndNotify();
    }
  }, [onReady]);

  return null;
};

export default CustomSplash; 